import { render } from "./HelpSheet.vue?vue&type=template&id=5c2b98f2&scoped=true&ts=true"
import script from "./HelpSheet.vue?vue&type=script&lang=ts"
export * from "./HelpSheet.vue?vue&type=script&lang=ts"

import "./HelpSheet.vue?vue&type=style&index=0&id=5c2b98f2&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/jahajibd.com/ia.jahajibd.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c2b98f2"]])

export default __exports__